export const emojisData = (state) => {
  return state.emojisData;
};
